import MarcaDelete from './MarcaDelete'
export {MarcaDelete}
export default MarcaDelete
